import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { AssemblyDisassemblyOfGoodsDto } from "src/components/Pages/Documents/Warehouse/AssemblyDisassemblyOfGoods/dtos/AssemblyDisassemblyOfGoodsDto";
import { AssemblyDisassemblyOfGoodsModel } from "../models/AssemblyDisassemblyOfGoodsModel";
import { FormProvider, useForm } from "react-hook-form";
import { AssemblyDisassemblyOperationTypeEnum } from "../dtos/AssemblyDisassemblyOperationTypeEnum";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupAccount } from "src/components/Shared/NewForms/NFLookupAccount";
import { NFTextAreaInput } from "src/components/Shared/NewForms/NFTextAreaInput";
import { useFetchAssemblyDisassemblyOfGoods } from "../hooks/fetchDocument";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";

interface IProps {
  model?: AssemblyDisassemblyOfGoodsDto | null;
  tabIndex: number;
  setTabIndex: React.Dispatch<React.SetStateAction<number>>;
  handleUploadFile?: (file: File) => void;
  exportToExcel?: () => void;
  fileName: string;
  setFileName: React.Dispatch<React.SetStateAction<string>>;
  id?:string;
}

export const DisassemblyOfGoodsDetail = ({id, model, tabIndex, setTabIndex, handleUploadFile, exportToExcel, fileName, setFileName }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<AssemblyDisassemblyOfGoodsModel>();
  const [showComponent1, setShowComponent1] = useState(false);
  const [showComponent2, setShowComponent2] = useState(false);

  const AssemblyDisassemblyOpertationType = [
    { id: AssemblyDisassemblyOperationTypeEnum.Assembly, name: "Assembly" },
    {
      id: AssemblyDisassemblyOperationTypeEnum.Disassembly,
      name: "Disassembly"
    }
  ];
  const watchOperationType = watch("operationType");

  useEffect(() => {
    switch (watchOperationType) {
      case AssemblyDisassemblyOperationTypeEnum.Assembly:
        setShowComponent1(true);
        setShowComponent2(false);
        break;
      case AssemblyDisassemblyOperationTypeEnum.Disassembly:
        setShowComponent1(false);
        setShowComponent2(true);
        break;
      default:
        setShowComponent1(false);
        setShowComponent2(false);
    }
  }, [watchOperationType]);
  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchAssemblyDisassemblyOfGoods({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };
  // const handleFormSubmit = async (
  //   action: DocumentSaveActionType,
  //   data: AssemblyDisassemblyOfGoodsModel
  // ) => {
  //   console.log("form submit");
  //   console.log(data);
  //   console.log(action);
  //   if (action === "save") {
  //     const newModel: AssemblyDisassemblyOfGoodsDto = { ...model, ...data };
  //     await saveHandler(newModel, action);
  //   } else if (action === "post") {
  //     const newModel: AssemblyDisassemblyOfGoodsDto = { ...model, ...data };
  //     await saveHandler(newModel, action);
  //     await postHandler(action);
  //   }
  // };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        {/* <DocumentModalViewHeader onPost={handleSubmit((data) => handleFormSubmit("post", data))}
                    onSave={handleSubmit((data) => handleFormSubmit("save", data))}
                    onClose={closeHandler} onCancel={cancelHandler}
                    handleUploadFile={handleUploadFile} exportToExcel={exportToExcel}
                    fileName={fileName} setFileName={setFileName} /> */}
           <DocumentDetailViewToolbar>
            <DetailViewPostButton onPost={handlePost} />
            <DetailViewCancelButton onCancel={handleCancel} />
          </DocumentDetailViewToolbar>
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} fieldName={"documentNumber"} disabled />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} />
            </Col>
            <Col sm={6}>
              <NFLookupAccount title={"Goods Account"} fieldName={"goodsAccount"} />
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <NFLookupWarehouse fieldName={"warehouseId"} title={"Warehouse"} companyId={watch("companyId")} />
            </Col>
            <Col sm={6}>
              <NFLookupDivision fieldName={"divisionId"} title={"Division"} companyId={watch("companyId")} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupProduct fieldName={"productId"} title={"Product"} />
            </Col>
            <Col sm={4}>
              <NFLookupUnit title={"Unit"} fieldName={"unit"} />
            </Col>
            <Col sm={2}>
              <NFTextInput fieldName={"quantity"} title={"Quantity"} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"postingOfGoodGoods"}>
            <NFLookupProduct fieldName={"productId"} title={"Product"} width={300} />
            <NFIntInput fieldName={"quantity"} title={"Quantity"} />
            <NFIntInput fieldName={"unit"} title={"Unit"} />
            <NFLookupAccount fieldName={"accountId"} title={"Account"} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
